import * as React from 'react';

import { QTYPES } from '@nexxt/common/types';
// Default form
import DefaultComponent from './questionType/default';
import GreetingText from './questionType/greetingText';
import RedirectText from './questionType/RedirectText/RedirectText';

// QuestionFormBase
import IconScale from './questionType/questionForm/iconScale';
import Multimedia from './questionType/questionForm/multimedia';
import VectorMap from './questionType/questionForm/vectormap';
import DepartingMessage from './questionType/questionForm/departingMessage';
import OpenEnded from './questionType/questionForm/openended';
import PII from './questionType/questionForm/PII';
import GroupQuestion from './questionType/questionForm/groupQuestion';
import GuidedFantasy from './questionType/questionForm/GuidedFantasy';
import Numeric from './questionType/questionForm/Numeric';

// QuestionFormWithOptionsBase
import FormChoice from './questionType/questionFormWithOptions/Choice';
import Scale from './questionType/questionFormWithOptions/scale';
import RankOrder from './questionType/questionFormWithOptions/rankOrder';
import AdBuilder from './questionType/questionFormWithOptions/adBuilder';
import Popup from './questionType/questionFormWithOptions/popup';
import RateImage from './questionType/questionFormWithOptions/rateImage';
import Virtual from './questionType/questionFormWithOptions/virtual';
import TradeOff from './questionType/questionFormWithOptions/tradeOff';
import Hotspot from './questionType/questionFormWithOptions/Hotspot';
import NPS from './questionType/questionFormWithOptions/NPS';
import TextHighlighter from './questionType/questionFormWithOptions/TextHighlighter';
import VideoAnnotation from './questionType/questionFormWithOptions/videoAnnotation';
import RapidChoice from './questionType/questionFormWithOptions/RapidChoice';

/**
 * QuestionEditorSwitch
 */
class QuestionEditorSwitch extends React.Component<{
    type: QTYPES;
}> {
    render() {
        switch (this.props.type) {
            case QTYPES.MULTIPLE_CHOICE:
                return <FormChoice />;
            case QTYPES.SINGLE_CHOICE:
                return <FormChoice />;
            case QTYPES.RANK_ORDER:
                return <RankOrder />;
            case QTYPES.AD_BUILDER:
                return <AdBuilder />;
            case QTYPES.ICONS:
                return <IconScale />;
            case QTYPES.SCALE:
                return <Scale />;
            case QTYPES.VECTOR_MAP:
                return <VectorMap />;
            case QTYPES.GREETING_TEXT:
                return <GreetingText />;
            case QTYPES.MULTIMEDIA:
                return <Multimedia />;
            case QTYPES.POPUP:
                return <Popup />;
            case QTYPES.OPEN:
                return <OpenEnded />;
            case QTYPES.PII:
                return <PII />;
            case QTYPES.RATE_IMAGE:
                return <RateImage />;
            case QTYPES.NPS:
                return <NPS />;
            case QTYPES.TRADE_OFF:
                return <TradeOff />;
            case QTYPES.VIDEO_ANNOTATION:
                return <VideoAnnotation />;
            case QTYPES.HOTSPOT:
                return <Hotspot type={QTYPES.HOTSPOT} />;
            case QTYPES.TREEMAN:
                return <Hotspot type={QTYPES.TREEMAN} />;
            case QTYPES.DEPARTING_MESSAGE:
                return <DepartingMessage />;
            case QTYPES.GROUP:
                return <GroupQuestion />;
            case QTYPES.VIRTUAL:
                return <Virtual />;
            case QTYPES.REDIRECT:
                return <RedirectText />;
            case QTYPES.TEXT_HIGHLIGHTER:
                return <TextHighlighter />;
            case QTYPES.GUIDED_FANTASY:
                return <GuidedFantasy />;
            case QTYPES.RAPID_CHOICE:
                return <RapidChoice />;
            case QTYPES.NUMERIC:
                return <Numeric />;
            default:
                //TODO: Change this component
                return <DefaultComponent />;
        }
    }
}

export default QuestionEditorSwitch;
